export default "__VITE_ASSET__e2c8420b__"